/**
 * Baixa os bytes de um arquivo (PDF/XML de nota, documento da empresa) a partir de uma URL
 * assinada do R2.
 *
 * Usa `fetch` puro de propósito: é um host externo (endpoint do R2) e mandar o
 * header `Authorization` do app não faz sentido. Requer CORS liberado no bucket
 * para a origem da PWA e o host no `connect-src` do CSP (`VITE_STORAGE_HOSTS`).
 */
export async function fetchDocumentBlob(documentUrl: string): Promise<Blob> {
  // `cache: 'no-store'` evita uma armadilha de CORS: o link "Abrir" abre a mesma
  // URL como navegação de topo (sem header Origin) e popula o cache do navegador
  // com uma resposta sem `Access-Control-Allow-Origin`. Reaproveitada aqui, o
  // fetch cross-origin falharia. Buscando sempre fresco, vêm os headers de CORS.
  const response = await fetch(documentUrl, { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Não foi possível baixar o documento (HTTP ${response.status}).`);
  }
  return response.blob();
}
